import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './index.css';
import { BrowserRouter } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";

const normalizeApiBaseUrl = (rawBaseUrl) => {
  const trimmed = (rawBaseUrl || "").trim();
  if (!trimmed) return "";

  try {
    const parsed = new URL(trimmed);
    const isLocalBackend = parsed.hostname === "localhost" || parsed.hostname === "127.0.0.1";

    // Most local Express setups run over HTTP, so gracefully correct accidental HTTPS.
    if (isLocalBackend && parsed.protocol === "https:") {
      parsed.protocol = "http:";
    }

    return parsed.toString().replace(/\/+$/, "");
  } catch {
    return trimmed.replace(/\/+$/, "");
  }
};

const apiBaseUrl = normalizeApiBaseUrl(process.env.REACT_APP_API_BASE_URL);
const isLocalFrontend =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

if (apiBaseUrl && !isLocalFrontend && typeof window !== "undefined" && typeof window.fetch === "function") {
  const originalFetch = window.fetch.bind(window);

  // In production deployments (e.g., Cloudflare Pages), rewrite relative /api calls
  // to the configured backend origin while keeping local dev proxy behavior unchanged.
  window.fetch = (input, init) => {
    if (typeof input === "string" && input.startsWith("/api/")) {
      return originalFetch(`${apiBaseUrl}${input}`, init);
    }

    if (input instanceof Request) {
      try {
        const requestUrl = new URL(input.url, window.location.origin);
        const isSameOriginApiCall =
          requestUrl.origin === window.location.origin && requestUrl.pathname.startsWith("/api/");

        if (isSameOriginApiCall) {
          const rewrittenUrl = `${apiBaseUrl}${requestUrl.pathname}${requestUrl.search}`;
          return originalFetch(new Request(rewrittenUrl, input), init);
        }
      } catch {
        // Fall through to original fetch for any URL parsing edge cases.
      }
    }

    return originalFetch(input, init);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>
);
